/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                              FORMATS                                                                                               ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FR_FORMAT = 'DD/MM/YYYY hh:mm';
export const DATE_TIME_SQL_FORMAT = 'YYYY-MM-DD HH:mm:SS';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                              LOCAL STORAGE KEYS                                                                                    ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const BOVICLIC_JWT_KEY = 'boviclic';
export const CURRENT_USER_KEY = 'currentUser';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                             OAUTH                                                                                                  ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const CLIENT_ID = 'client_id';
export const CLIENT_SECRET = 'client_secret';
export const GRANT_TYPE = 'grant_type';
export const USERNAME = 'username';
export const PASSWORD = 'password';
export const REFRESH_TOKEN = 'refresh_token';
export const GT_REFRESH_TOKEN = 'refresh_token';
export const GT_PASSWORD = 'password';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                             OFFICES                                                                                                ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const SITE = 'internet_site';
export const BOVICLIC = 'internet_boviclic';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                             OPEN MODES                                                                                             ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const CREATE = 'create';
export const EDIT = 'edit';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                             VALIDATION LENGTHS                                                                                     ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const RP_ADDRESS_MAX_LENGTH = 30;
export const RP_NAME_MAX_LENGTH = 255;
export const ZIP_MAX_LENGTH = 6;
export const ZIP_MIN_LENGTH = 4;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                             STYLE                                                                                                  ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const BACKGROUND_COLOR = 'background-color';
export const COLOR_PRIMARY_LIGHT = 'rgba(117, 54, 230, .1)';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                             ROUTING PATHS                                                                                          ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const BOVICLIC_PATH = '/boviclic';
export const BOVICLIC_ERROR_PATH = '/boviclic-error';
export const HOME_PATH = '/home';
export const LOGIN_PATH = '/login';
export const REMOVAL_POINTS_PATH = '/removal-points';
export const REMOVAL_PATH = '/removal';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                             OTHER VALUES                                                                                           ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ID = 'ID';

export const REQUIRED = 'required';
export const PATTERN = 'pattern';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                             INPUT TYPES                                                                                            ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const IT_PASSWORD = 'password';
export const IT_TEXT = 'text';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                             TOASTR                                                                                                 ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const TOASTR_CONFIG = {
  closeButton: true,
  extendedTimeOut: 3000,
  newestOnTop: true,
  preventDuplicates: false,
  positionClass: 'toast-top-center',
  progressBar: true,
  timeOut: 10000
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///                             ERRORS KIND                                                                                            ///
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const ERROR_MESSAGE_IS_ARRAY = 100;

export const ERROR_KIND_CODE_MESSAGE = 100;
